import React from 'react';

import { LatencyCard, fmtMs, fmtNum } from './LatencyCard';
import type { ModelsResponse } from '../../../../../api';

type Props = {
  data?: ModelsResponse | null;
  loading?: boolean;
};

export const ModelsSummaryTable: React.FC<Props> = ({ data, loading }) => {
  const items = data?.items ?? [];

  return (
    <LatencyCard
      title="Models summary"
      subtitle="latency by provider / model"
      loading={loading}
      isEmpty={items.length === 0}
    >
      <div className="h-full overflow-auto">
        <table className="w-full text-small text-left">
          <thead className="text-secondary sticky top-0 bg-white">
            <tr className="border-b">
              <th className="py-2 pr-3 font-medium">Provider</th>
              <th className="py-2 pr-3 font-medium">Model</th>
              <th className="py-2 pr-3 font-medium">Type</th>
              <th className="py-2 pr-3 font-medium text-right">Events</th>
              <th className="py-2 pr-3 font-medium text-right">p50</th>
              <th className="py-2 pr-3 font-medium text-right">p95</th>
              <th className="py-2 pr-0 font-medium text-right">p99</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr
                key={`${item.provider}-${item.model}-${item.metric_type}-${index}`}
                className="border-b last:border-0"
              >
                <td className="py-2 pr-3">{item.provider || '—'}</td>
                <td className="py-2 pr-3">{item.model || '—'}</td>
                <td className="py-2 pr-3">{item.metric_type}</td>
                <td className="py-2 pr-3 text-right">
                  {fmtNum(item.events_count)}
                </td>
                <td className="py-2 pr-3 text-right">
                  {fmtMs(item.p50_latency_ms)}
                </td>
                <td className="py-2 pr-3 text-right">
                  {fmtMs(item.p95_latency_ms)}
                </td>
                <td className="py-2 pr-0 text-right">
                  {fmtMs(item.p99_latency_ms)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </LatencyCard>
  );
};
